module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-nav"
  }, [_c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.listItems), function(listItem, index) {
    return _c('li', {
      directives: [{
        name: "track-by",
        rawName: "v-track-by",
        value: (index),
        expression: "index"
      }],
      staticClass: "index-list",
      on: {
        "mouseover": _vm.addClass
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: _vm.routeName,
          params: {
            parcoursId: _vm.itemId,
            epigramIndex: index + 1
          }
        }
      }
    }, [_c('span', {
      staticClass: "dash"
    }, [_c('span', {
      staticClass: "inner-dash"
    })]), _vm._v("\n                " + _vm._s(listItem.title) + "\n                "), _c('sup', [_vm._v(_vm._s(_vm._f("romanize")(index + 1)))])])], 1)
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef158734"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/IndexNav.vue
// module id = 113
// module chunks = 0